
//Note: don't mutate games on Lobby
//Note: shownGames will be useful for game grouping and identifying that it has a group
const groupedGames = ["m22", "p7"];

// To set game group:
// call setLobbyGameGroup --> setGameGroup

//Note: don't use mutated games
function setLobbyGameFilter(e: any) {
	const filter = e !== undefined ? e.currentTarget.getAttribute("filter") : "all";

	this.setState({
		lobbyGameFilter: filter,
		showCategories: false
	});
}

function toggleShowGameGroup(e: any) {
	if (e) {
		const isMobile = e.currentTarget.getAttribute("mobile");
		
		if (isMobile === "true")
			this.setState({ showAllRoadmap: false });
	}

	this.setState({
		showLobbyGameGroup: !this.state.showLobbyGameGroup
	});
}

/**
 * for use in Lobby (desktop) & LobbyMobile
 */
function bindCommonGameGroupingFunctions(mainClass: any) {
	mainClass.toggleShowGameGroup = toggleShowGameGroup.bind(mainClass);
	mainClass.setLobbyGameFilter = setLobbyGameFilter.bind(mainClass);
}

//New game grouping system
function activateGameGroup(e: any) {
	const group = e.currentTarget.getAttribute("group"),
		mobile = e.currentTarget.getAttribute("mobile") === "true";
	// console.log("aGG", pcode);
	
	this.setState({
		showAllRoadmap: mobile,

		showLobbyGameGroup: true,
		activeGameGroup: group
	});
}

export {
	//Const
	groupedGames,
	
	//Desktop & mobile
	setLobbyGameFilter,
	toggleShowGameGroup,
	
	activateGameGroup,
	
	bindCommonGameGroupingFunctions
};
